import React from "react";
import image from '../../../images/situation/luikbreedte/luikbreedte.jpg'
import PropTypes from "prop-types";

Breedte.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    onEnter: PropTypes.func.isRequired
}
export default function Breedte(props) {
    return <div className="phone-page-middle">
        <div className="phone-situation-title">
            Hier kunt u invullen wat de breedte van de luiken is, in milimeters.<br/>
        </div>
        <div className="phone-situation-description">
            Voorbeeld:<br/>
            Als uw luik 60 cm breed is, voert u 600 in als waarde.<br/>
        </div>
        <input
            className="phoneInput"
            inputMode="numeric"
            onKeyDown={event => event.key === 'Enter' ? props.onEnter() : null}
            onChange={props.onChange}
            value={props.value}
            type="number"
            placeholder="Vul hier de luikbreedte in..."
        />
        <img className="explainImagePhone" src={image} alt=""/>
    </div>;
}